import { render } from "./comments.web.vue?vue&type=template&id=0e14c8e0&scoped=true"
import script from "./comments.vue.js?vue&type=script&lang=js"
export * from "./comments.vue.js?vue&type=script&lang=js"

import "./comments.web.vue?vue&type=style&index=0&id=0e14c8e0&scoped=true&lang=css"

import exportComponent from "D:\\PC-Data\\Code\\jdqus\\public\\webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e14c8e0"],['__file',"src/vue/_components/article/comments/comments.web.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e14c8e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e14c8e0', __exports__)) {
    api.reload('0e14c8e0', __exports__)
  }
  
  module.hot.accept("./comments.web.vue?vue&type=template&id=0e14c8e0&scoped=true", () => {
    api.rerender('0e14c8e0', render)
  })

}


export default __exports__